import { render, staticRenderFns } from "./chuandialog.vue?vue&type=template&id=37d2059a&scoped=true"
import script from "./chuandialog.vue?vue&type=script&lang=js"
export * from "./chuandialog.vue?vue&type=script&lang=js"
import style0 from "./chuandialog.vue?vue&type=style&index=0&id=37d2059a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2059a",
  null
  
)

export default component.exports